import React from "react";
import { SnapGuide } from "../../hooks/useSnapGuides";

// Pink Figma-style alignment guide lines. Render inside the (position:
// relative) page canvas element; positions are unscaled PDF points.
const SnapGuideLines: React.FC<{ guides: SnapGuide[]; scale: number }> = ({
  guides,
  scale,
}) => (
  <>
    {guides.map((g, i) => (
      <div
        key={`${g.orientation}-${i}`}
        className="absolute pointer-events-none z-30"
        style={
          g.orientation === "vertical"
            ? {
                left: g.position * scale,
                top: 0,
                width: 1,
                height: "100%",
                backgroundColor: "#ec4899",
              }
            : {
                top: g.position * scale,
                left: 0,
                height: 1,
                width: "100%",
                backgroundColor: "#ec4899",
              }
        }
      />
    ))}
  </>
);

export default SnapGuideLines;
